export var PartnerType;
(function (PartnerType) {
    PartnerType[PartnerType["Broker"] = 0] = "Broker";
    PartnerType[PartnerType["Super_Broker"] = 1] = "Super_Broker";
    PartnerType[PartnerType["White_Label"] = 2] = "White_Label";
})(PartnerType || (PartnerType = {}));
